export default "__VITE_ASSET__cf9e8e6c__"